import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

export class GetSellerService extends Service {
  constructor({config, getDealerService, getUserService, sellerValueObjectFactory}) {
    super()

    this._config = config
    this._getDealerService = getDealerService
    this._getUserService = getUserService
    this._sellerValueObjectFactory = sellerValueObjectFactory
  }

  _getDealer({sellerRequestVO: requestVO}) {
    return this._getDealerService.execute({requestVO})
  }

  _getUser({sellerRequestVO: requestVO}) {
    return this._getUserService.execute({requestVO})
  }

  @inlineError
  async execute({sellerRequestVO}) {
    const {contractId, isDealer, isPrivate} = sellerRequestVO.toJSON()

    const [error, entity] = isDealer ? await this._getDealer({sellerRequestVO}) : await this._getUser({sellerRequestVO})

    if (error) return Promise.reject(error)

    const sellerValueObject = this._sellerValueObjectFactory({
      contractId,
      isDealer,
      isPrivate,
      ...(isDealer && {dealer: entity}),
      ...(isPrivate && {user: entity})
    })

    return sellerValueObject
  }
}
